import { Component, OnInit, EventEmitter,Input, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { AsignacionCajaService } from '../../../services/asignacion-caja.service';
import { AsignacionCaja } from '../../../models/asignacion-caja';
import * as moment from 'moment';
import { ArqueoCaja } from '../../../models/arqueo_caja';
import { SessionService } from '../../../services/session.service';
import { ArqueoCajaService } from '../../../services/arqueo-caja.service';
import { SweetMessage } from '../../../config/sweet-message';
import { Validation } from '../../../config/validation';
import { UtilsService } from '../../../services/utils.service';
import { ParametroService } from '../../../services/parametro.service';
@Component({
  selector: 'app-reposicion-caja-modal',
  templateUrl: './reposicion-caja-modal.component.html',
  styleUrls: ['./reposicion-caja-modal.component.css'],
  providers: [
	AsignacionCajaService,
	SessionService,
	ArqueoCajaService,
	ParametroService
  ]
})
export class ReposicionCajaModalComponent implements OnInit {
	@Input() asignacion_id: string;
	public loading: boolean;
	public asignacion: AsignacionCaja;
	public valor_reposicion:number;
	public fecha_emision;
	public arqueo: ArqueoCaja;
	public observacion: string;
	public msgSweet: SweetMessage;
	public vl: Validation;
	public asignacion1: any;
	public ajuste: boolean;
	public calculo_decimales: number;
	public format_decimal: String;
	public numero_decimales: number;

	constructor(
		public bsModalRef: BsModalRef,
		public asignacionService: AsignacionCajaService,
		public ss: SessionService,
		public arqueoService: ArqueoCajaService,
		public utils: UtilsService,
		private parametroService: ParametroService,
	) { 
		
		this.loading = false;
		this.asignacion = new AsignacionCaja();
		this.valor_reposicion = 0;
		this.fecha_emision = moment(this.fecha_emision);
		this.arqueo = new ArqueoCaja();
		this.observacion = "";
		this.msgSweet = new SweetMessage();
		this.vl = new Validation();
		this.asignacion1 = [];
		this.calculo_decimales = 2;
		this.format_decimal = "0,0.00";
		this.numero_decimales = 2;
	}

	ngOnInit() {
		//let p1 = this.getDataAsignacion();
		let p1 = this.getData();
		let p2 = this.getParamNumeroDecimales();
		
		this.loading = true;
        Promise.all([p1,p2]).then(
            res => this.loading = false,
            err => this.loading = false
        );
	}

	getData(){
		return new Promise((resolve, reject) => {
			this.asignacionService.getDataById(this.asignacion_id).subscribe(
				res => {
					this.asignacion1 = res.data[0];
					this.calcularValorAjuste();
					resolve();
				},
				err => {
					reject(err);
				}
			);
		});
	}

	getParamNumeroDecimales(){
        return new Promise((resolve, reject) => {
            let numero_decimales = 19;
            this.parametroService.getById(numero_decimales).subscribe(
                res => {
                    this.numero_decimales = res.valor;

                    let digitos = "";
                    for(let i = 0; i < this.numero_decimales; i++) digitos += "0";

                    this.format_decimal = "0,0." + digitos
                    resolve();
                },
                err => {
                    this.numero_decimales = 2;
                    this.format_decimal = "0,0.00"
                    reject(err);
                }
            );
        });
    }

	calcularValorAjuste(){
		this.asignacion1.valor_apertura = this.utils.redondear(this.asignacion1.valor_apertura, this.calculo_decimales);
		this.asignacion1.valor_facturado = this.utils.redondear(this.asignacion1.valor_facturado, this.calculo_decimales);
		this.asignacion1.valor_cierre = this.utils.redondear(this.asignacion1.valor_cierre, this.calculo_decimales);
		this.asignacion1.gasto_total = this.utils.redondear(this.asignacion1.gasto_total, this.calculo_decimales);
		this.asignacion1.valor_reposicion = this.utils.redondear(this.asignacion1.valor_reposicion, this.calculo_decimales);
		this.asignacion1.valor_sobrante = this.utils.redondear(this.asignacion1.valor_sobrante, this.calculo_decimales);
		this.asignacion1.valor_total = this.asignacion1.valor_apertura + this.asignacion1.valor_facturado;
		
		if( this.asignacion1.valor_total >= this.asignacion1.valor_cierre ){
			this.ajuste = false;
			this.asignacion1.valor_ajuste = this.asignacion1.valor_total - this.asignacion1.valor_cierre - this.asignacion1.valor_reposicion;
			
		}else /*if ( this.asignacion1.valor_total < this.asignacion1.valor_cierre )*/{
			this.ajuste =  true;
			this.asignacion1.valor_ajuste = this.asignacion1.valor_cierre - this.asignacion1.valor_total - this.asignacion1.valor_sobrante;
		}

		this.asignacion1.valor_ajuste = this.utils.redondear(this.asignacion1.valor_ajuste, this.calculo_decimales);
	}

	/*getDataAsignacion(){
		return new Promise((resolve, reject) => {
			let qs = "?embed=caja,usuario";
			this.asignacionService.getById(this.asignacion_id, qs).subscribe(
				res => {
					this.asignacion = res;
					resolve();
				},
				err => {
					reject(err);
				}
			);
		});
	}*/

	onSubmit(){
		this.setReposicion();
		this.arqueoService.save(this.arqueo).subscribe(
			res => {
				this.msgSweet.showMessage('success-message', 'Se ha procesado correctamente');
				this.bsModalRef.hide();
			},
			err => {
				this.msgSweet.showMessage('error-message', "Ha ocurrido un error");
			}
		);
	}

	setReposicion(){
		this.arqueo.asignacion_caja_id = this.asignacion1.id;

		if( this.ajuste ){
			this.arqueo.definicion_id = "6";
			this.arqueo.tipo = "AJ";
		}
		if( this.ajuste == false ){
			this.arqueo.definicion_id = "5";
			this.arqueo.tipo = "R";
		}

			//[disabled]="!isValidForm()"

		this.arqueo.empresa_id = this.asignacion1.empresa_id;
		this.arqueo.sucursal_id = this.asignacion1.sucursal_id;
		this.arqueo.fecha = moment(this.fecha_emision).format("YYYY-MM-DD");
		this.arqueo.observacion = this.observacion;
		this.arqueo.usuario_id = this.asignacion1.usuario_id;
		this.arqueo.usuario_reposicion_id = this.ss.getData("usuario_id");
		this.arqueo.valor = this.asignacion1.valor_ajuste;
	}

	isValidForm(){
        if( this.observacion == "" ){
            return false;
		}
		
        return true;
	}
	
	get formatDecimal(){
        return this.format_decimal;
    }

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/reposicion-caja-modal/reposicion-caja-modal.component.ts